import { render } from "./EditPasswordTitle.vue?vue&type=template&id=75557020"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "75557020"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75557020', script)) {
    api.reload('75557020', script)
  }
  
  module.hot.accept("./EditPasswordTitle.vue?vue&type=template&id=75557020", () => {
    api.rerender('75557020', render)
  })

}

script.__file = "src/views/settings/pageTitles/EditPasswordTitle.vue"

export default script